import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class QuotationService extends BaseService {

    static url = "quotations";
    static apis = {
        that: this,
        getMadeOffers: {path: this.url + "/getMadeOffers"
        , method: "GET"},
        getReceivedOffers: {path:this.url + "/getReceivedOffers"
        , method: "GET"},
        rejectQuotes: {path:this.url + "/rejectQuotes"
        , method: "POST"}

    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("quotations");
    }


    rejectQuotes(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: QuotationService.apis.rejectQuotes.path,
                    data: data,
                    method: QuotationService.apis.rejectQuotes.method,
                    authorization: true,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    getMadeOffers() {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: QuotationService.apis.getMadeOffers.path,
                    method: QuotationService.apis.getMadeOffers.method,
                    authorization: true,
                    
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    getReceivedOffers() {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: QuotationService.apis.getReceivedOffers.path,
                    method: QuotationService.apis.getReceivedOffers.method,
                    authorization: true,
                    
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


}

export default QuotationService;